import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const sipBusinessReportApi = createAsyncThunk(
  "sipBusinessReport",
  async ({partner_id="", name = "", startDate = "", endDate = "" }) => {
    const params = {};
    // Add name to the query if provided
    if (partner_id) {
      params.partner_id = partner_id;
    }
    if (name) {
      params.name = name;
    }
    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    const response = await axiosInstance.get("/report/sipBusinessReport", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      return response.data;
    }
  }
);

const sipBusinessReportSlice = createSlice({
  name: "sipBusinessReport",
  initialState: {
    sipBusinessReport: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sipBusinessReportApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(sipBusinessReportApi.fulfilled, (state, action) => {
        state.sipBusinessReport = action.payload;
        state.loading = false;
      })
      .addCase(sipBusinessReportApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sipBusinessReportSlice.reducer;

